import { Icon, Span } from '@pandiafi/design-system'
import React from 'react'

export const PasswordRequirementItem: React.FC<{
  text: string
  isError: boolean
}> = ({ text, isError }) => (
  <div
    className="flex gap-s items-center"
    style={{
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      '--icon-balloon-background-color': isError ? 'red' : 'green',
      color: 'white',
    }}
  >
    <Icon icon={isError ? 'x-mark' : 'check'} size="sm" variant="balloon" />
    <Span>{text}</Span>
  </div>
)
